export const GTM_CONTAINER_ID_EN_US = process.env.NEXT_PUBLIC_GTM_CONTAINER_ID_EN_US;
export const GTM_CONTAINER_ID_EN_CA = process.env.NEXT_PUBLIC_GTM_CONTAINER_ID_EN_CA;
export const GTM_CONTAINER_ID_FR_CA = process.env.NEXT_PUBLIC_GTM_CONTAINER_ID_FR_CA;
export const GTM_CONTAINER_ID_ES_MX = process.env.NEXT_PUBLIC_GTM_CONTAINER_ID_ES_MX;
export const GTM_CONTAINER_ID_ES_419 = process.env.NEXT_PUBLIC_GTM_CONTAINER_ID_ES_419;
export const GTM_CONTAINER_ID_PR_BR = process.env.NEXT_PUBLIC_GTM_CONTAINER_ID_PR_BR;
